import { Controller } from "@hotwired/stimulus"

const KEY = "age-confirmed"

// The 18+ notice. Shown only by JS and only until the visitor confirms, so
// the page itself stays in the HTML for crawlers.
export default class extends Controller {
  connect() {
    if (this.confirmed()) return

    this.element.hidden = false
    document.documentElement.classList.add("overflow-hidden")
    this.element.querySelector("button")?.focus()
  }

  enter() {
    try {
      localStorage.setItem(KEY, "1")
    } catch {
      // Private mode or blocked storage: the notice just comes back next visit.
    }
    this.element.hidden = true
    document.documentElement.classList.remove("overflow-hidden")
  }

  confirmed() {
    try {
      return localStorage.getItem(KEY) === "1"
    } catch {
      return false
    }
  }
}
